import type { TargetAndTransition, Transition } from "motion/react";

/** Matches `RippleButton` `buttonTransition` + default hover/tap scale. */
export const CTA_RIPPLE_BUTTON_TRANSITION: Transition = {
	duration: 0.1,
	ease: [0.4, 0, 0.2, 1],
};

/** Same as `RippleButton` when `appearance="default"` (hover scale). */
export const CTA_RIPPLE_BUTTON_WHILE_HOVER: TargetAndTransition = {
	scale: 1.03,
	transition: CTA_RIPPLE_BUTTON_TRANSITION,
};

/** Same as `RippleButton` when `appearance="default"` (tap scale). */
export const CTA_RIPPLE_BUTTON_WHILE_TAP: TargetAndTransition = {
	scale: 0.97,
	transition: CTA_RIPPLE_BUTTON_TRANSITION,
};
